import React from 'react';
import { motion } from 'framer-motion';

const InputSection = ({ title, children }) => {
  return (
    <motion.div 
      className="space-y-4"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h3 className="text-lg font-medium text-gray-900 border-b border-gray-200 pb-2">
        {title}
      </h3>
      {children}
    </motion.div>
  );
};

export default InputSection;